import React from 'react';
import SlideBar from '../components/SliderBar/SliderBar.jsx';
import TableClient from '../components/TableClient/TableClient.jsx';


export const Consult = () => {
  return (
    <>
        <SlideBar />
        <TableClient />
    </>
  );
}

export default Consult;